export const dayPluralMap = {
  '=1': 'day',
  other: 'days',
};
